<template>
  <div class="rank">
    <div class="header">
      <img
        class="header_bg"
        src="http://img.wish.hebyun.com.cn/images/rank_banner.png"
      />
    </div>
    <div class="contents">
      <!-- 切换头部 -->
      <div class="tab_headers">
        <div
          v-for="(item, index) in tabs"
          :key="index"
          class="tab_header"
          :class="tab == item ? 'active' : ''"
          @click="toggleTab(item)"
        >
          <span>{{ item }}</span>
        </div>
      </div>
      <div class="lists">
        <table class="rankingArea">
          <thead class="thead">
            <tr>
              <th class="ranking">排名</th>
              <th class="region">单位</th>
              <th class="wish_num">心愿值</th>
            </tr>
          </thead>
          <tbody class="tbody">
            <tr v-for="wish in wishList" :key="wish.rank">
              <td class="ranking">
                <img
                  v-if="wish.rank === 1"
                  src="http://img.wish.hebyun.com.cn/images/first.png"
                />
                <img
                  v-if="wish.rank === 2"
                  src="http://img.wish.hebyun.com.cn/images/second.png"
                />
                <img
                  v-if="wish.rank === 3"
                  src="http://img.wish.hebyun.com.cn/images/third.png"
                />
                <div v-if="wish.rank > 3" class="number">
                  {{ wish.rank }}
                </div>
              </td>
              <td class="region">{{ wish.name }}</td>
              <td class="wish_num">{{ wish.points }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="side_bars">
      <img
        src="http://img.wish.hebyun.com.cn/images/share_icon.png"
        @click="share"
      />
    </div>
  </div>
</template>
<script>
let tabs = "省直,市级,县级".split(",");

export default {
  name: "rank",
  components: {},
  data() {
    return {
      tabs,
      tab: tabs[0],
      type: 1,
      wishList: [],
    };
  },
  created() {
    this.queryRank();
  },
  methods: {
    share() {
      var url = window.location.href;

      var msg = {
        shareTitle: "我为群众办实事 党员帮办微心愿",
        shareSummary: "提交心愿、认领心愿、互动点赞，请登录“冀云”客户端",
        shareUrl: url,
        shareImage: "http://img.wish.hebyun.com.cn/images/wyxShare.jpg",
      };
      const u = navigator.userAgent,
        app = navigator.appVersion;
      console.log(app);
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isiOS) {
        window.webkit.messageHandlers.nativeShare.postMessage(
          JSON.stringify(msg)
        );
      } else {
        window.jsInterface.nativeShare(JSON.stringify(msg));
      }
    },
    // 切换
    toggleTab(e) {
      this.tab = e;
      if (e === "省直") {
        this.type = 1;
        this.tab = "省直";
      } else if (e === "市级") {
        this.type = 2;
        this.tab = "市级";
      } else if (e === "县级") {
        this.type = 3;
        this.tab = "县级";
      }
      this.wishList = [];
      this.queryRank();
    },
    // 查询排行榜
    async queryRank() {
      let { data } = await this.$api.queryWishRank(this.type);
      console.log(data);
      this.wishList = data;
    },
  },
};
</script>

<style scoped lang="scss">
.rank {
  width: 100%;
  background-color: rgba(167, 31, 36, 1);
  min-height: 100vh;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  .header {
    position: relative;
    width: 100%;
    height: 143px;
    .header_bg {
      width: 100%;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 0;
      height: 165.5px;
    }
  }
  .contents {
    width: 345px;
    height: 600px;
    background-color: #fff8d6;
    border-radius: 10px;
    z-index: 1;
    padding-top: 15px;
    /* 切换头部 */
    .tab_headers {
      display: flex;
      align-items: center;
      height: 39px;
      line-height: 39px;
      .tab_header {
        position: relative;
        flex: 1;
        text-align: center;
        font-size: 16px;
        color: #333333;
      }
      .tab_header::before {
        content: "";
        position: absolute;
        left: 0;
        top: 12.5px;
        width: 1px;
        height: 13px;
        background-color: #e60012;
      }
      .tab_header:first-child::before {
        background-color: transparent;
        width: 0;
      }
      .active {
        color: #e50012;
        position: relative;
      }

      .active::after {
        content: "";
        position: absolute;
        bottom: 5px;
        left: 50%;
        margin-left: -12.5px;
        width: 25px;
        height: 1px;
        background-color: #e60012;
      }
    }
    table {
      width: 314px;
      margin: auto;
      text-align: center;
      .ranking {
        width: 40px;
        font-size: 13px;
        font-weight: 400;
        line-height: 17.5px;
        letter-spacing: 1.5px;
        color: #666666;
        text-align: left;
      }
      .thead {
        tr {
          th {
            padding: 12px 0;
          }
        }

        .region {
          width: 217px;
          padding-left: 15px;
          font-size: 13px;
          font-weight: 400;
          line-height: 17.5px;
          letter-spacing: 1.5px;
          color: #666666;
          text-align: left;
          border-bottom: none;
        }
        .wish_num {
          width: 50px;
          font-size: 13px;
          font-weight: 400;
          line-height: 17.5px;
          letter-spacing: 1.5px;
          color: #666666;
          border-bottom: none;
        }
      }
      .tbody {
        td {
          img {
            width: 19.5px;
            height: 27.5px;
          }
        }
        tr {
          height: 55px;
        }
        .region {
          padding-left: 15px;
          text-align: left;
          font-size: 13px;
          font-weight: 400;
          letter-spacing: 1.5px;
          color: #333333;
          border-bottom: 1px solid rgba(255, 0, 0, 0.1);
        }
        .wish_num {
          font-size: 13px;
          font-weight: 800;
          letter-spacing: 1.5px;
          color: #e50012;
          border-bottom: 1px solid rgba(255, 0, 0, 0.1);
        }
        .number {
          width: 19px;
          height: 19px;
          background-color: #e50012;
          font-size: 10px;
          font-weight: 400;
          letter-spacing: 1px;
          text-align: center;
          border-radius: 100%;
          line-height: 19px;
          color: #f9f1c6;
        }
      }
    }
  }
}
</style>
